import { auth } from './firebase';
import { analyticsApiConfig } from '@config/app.config';

// Bridges the admin analytics UI to the GA4 Cloud Functions
// (functions/lib/analytics/ga4.js). GA4 Data API cannot be queried from the
// browser, so both the report and the AI assistant run server-side behind
// admin-gated endpoints (same auth pattern as contentLoopReview.js).

async function authedFetch(url, options = {}) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('You must be signed in as an admin to view analytics.');
  }
  const idToken = await user.getIdToken();

  const res = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
      ...(options.headers || {}),
    },
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.details || data.error || `Request failed with status ${res.status}`);
  }
  return data;
}

/**
 * Fetch the full GA4 report bundle (totals + trend + top pages + sources +
 * devices + countries + events) for the last `days` days.
 * @param {7|28|90} days
 */
export async function fetchGa4Report(days = 28) {
  const data = await authedFetch(`${analyticsApiConfig.reportUrl}?days=${days}`);
  return data.report;
}

/**
 * Ask the Gemini-backed assistant for a prioritized action plan based on the
 * same GA4 data. Returns { summary, actions: [{ priority, title, why, how }] }.
 * @param {7|28|90} days
 */
export async function fetchGa4Advice(days = 28) {
  const data = await authedFetch(analyticsApiConfig.assistantUrl, {
    method: 'POST',
    body: JSON.stringify({ days }),
  });
  return data.advice;
}
